/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Retracked from 'js/app/retracked';

import { Accordion } from '@coursera/cds-core';
import type { AccordionProps } from '@coursera/cds-core';
import type { Accordion as AccordionTrackingData, SectionName } from '@coursera/event-pulse-types';

import { useDegreeDescriptionEventingContext } from 'bundles/degree-description/providers/DegreeDescriptionEventingProvider';

type Props = {
  accordionVariant?: AccordionProps['variant'];
  trackingName: string;
  eventingV3TrackingData?: AccordionTrackingData;
  trackingSection?: SectionName;
  children: AccordionProps['children'];
  defaultExpanded?: boolean;
  withPadding?: boolean;
};

const styles = {
  accordionItem: css`
    & .cds-AccordionRoot-focusContainer {
      padding: 0;
    }
  `,
};

const trackingData = { namespace: { app: 'degree_description_app', page: 'degree_description_page' } };

const FaqModuleAccordionItem = ({
  accordionVariant = 'silent',
  trackingName,
  eventingV3TrackingData,
  trackingSection,
  children,
  defaultExpanded,
  withPadding = false,
}: Props) => {
  const { trackAccordion } = useDegreeDescriptionEventingContext();

  const handleOnChange = (event: unknown, expanded: boolean) => {
    if (expanded === true) {
      Retracked.trackComponent(trackingData, {}, `${trackingName}_expand`, 'click');
    } else {
      Retracked.trackComponent(trackingData, {}, `${trackingName}_collapse`, 'click');
    }

    if (!eventingV3TrackingData) return;
    trackAccordion(expanded, eventingV3TrackingData, trackingSection);
  };

  return (
    <Accordion
      variant={accordionVariant}
      css={withPadding ? null : styles.accordionItem}
      onChange={handleOnChange}
      defaultExpanded={defaultExpanded}
    >
      {children}
    </Accordion>
  );
};

export default FaqModuleAccordionItem;
